// Every stream event updates the same assistant message. Do not rely on an
// external boolean proving a placeholder still exists in React state.
export function upsertStreamMessage(items, { streamId, content, mode, source, taskWorkspace }) {
  const index = items.findIndex(message => message?.role === 'assistant' && message?.data?._normalChatStreamId === streamId);
  const existing = index >= 0 ? items[index] : null;
  const workspace = taskWorkspace || existing?.data?.taskWorkspace;
  const message = {
    ...existing,
    role: 'assistant',
    content: typeof content === 'string' && content ? content : existing?.content || workspace?.question || 'Working on your request.',
    mode: mode || existing?.mode || 'text',
    data: {
      ...existing?.data,
      _normalChatStreamId: streamId,
      ...(source ? { source } : {}),
      ...(workspace ? { taskWorkspace: workspace } : {}),
    },
  };
  if (index < 0) return [...items, message];
  return items.map((item, i) => i === index ? message : item);
}

export function latestWorkspaceIndex(messages) {
  return messages.reduce((latest, message, index) => message?.role === 'assistant' && message?.data?.taskWorkspace ? index : latest, -1);
}
